(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-trotting/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-trotting/assets/javascripts/init-box.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_trotting = svs.themes.sport_trotting || {};

  svs.themes.sport_trotting.initStatusStart = function(data) {
    if (svs.themes.sport_trotting.isEnded(data.status.id)) {
      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">Slut</div>';
    } else if (data.startTime) {
      return (
        '<div class="brick match-status brick-border f-condensed align-center">' +
        svs.themes.formatTime(data.startTime) +
        '</div>'
      );
    }
    return '';
  };

  svs.themes.sport_trotting.hasMatchMinutes = function() {
    return false;
  };
})(svs);

 })(window);